var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.083 13.25H4.708V8.292H9.292V13.25H11.917V5.875L7 2.167L2.083 5.875V13.25ZM2.083 14.583C1.72233 14.583 1.41 14.4513 1.146 14.188C0.882 13.924 0.75 13.6113 0.75 13.25V5.875C0.75 5.66634 0.798667 5.46834 0.896 5.281C0.993333 5.09367 1.12533 4.93734 1.292 4.812L6.208 1.104C6.31933 1.02067 6.44433 0.958337 6.583 0.917004C6.72233 0.875004 6.86133 0.854004 7 0.854004C7.15267 0.854004 7.295 0.875004 7.427 0.917004C7.559 0.958337 7.68067 1.02067 7.792 1.104L12.708 4.812C12.8747 4.93734 13.0067 5.09367 13.104 5.281C13.2013 5.46834 13.25 5.66634 13.25 5.875V13.25C13.25 13.6113 13.118 13.924 12.854 14.188C12.59 14.4513 12.2777 14.583 11.917 14.583H7.958V9.625H6.042V14.583H2.083Z",
    fill: "#51606F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.e3d8a23b8752db525a5cdeee4bd446d3.svg";
export { ForwardRef as ReactComponent };